import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-wrapper scroll-wrapper login-form-limited" }
const _hoisted_2 = { class: "modal__description" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = {
  key: 0,
  class: "error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $setup.props.isOpen,
    onClose: $setup.onClose,
    classes: "reset-password-modal height-limited"
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "modal__title" }, "Reset your password", -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("form", {
            onSubmit: _withModifiers($setup.onSubmit, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("label", null, [
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "label" }, "Email", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["input-large", { 'input--error': $setup.v$.email.$error }]),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.email) = $event)),
                  placeholder: "Email"
                }, null, 2), [
                  [_vModelText, $setup.form.email]
                ])
              ]),
              ($setup.v$.email.$error || $setup.props.message)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($setup.v$.email.$error ? $setup.v$.email.$errors[0].$message : $setup.props.message), 1))
                : _createCommentVNode("", true)
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("button", { class: "button primary large w-100" }, "Send reset password link", -1))
          ], 32)
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}